module.exports = __webpack_public_path__ + "img/6.1342d483.png";